import classNames from 'classnames';
import './style.scss';

const LoadingIndicator = ({ isSmall, contentClassName }: { isSmall?: boolean; contentClassName?: string }) => (
  <div className={classNames('loading-indicator', contentClassName, { 'loading-indicator--small': isSmall })}>
    <div className={classNames('loading-indicator__bounce', { 'loading-indicator__bounce--small': isSmall })} />
    <div className={classNames('loading-indicator__bounce', { 'loading-indicator__bounce--small': isSmall })} />
    <div className={classNames('loading-indicator__bounce', { 'loading-indicator__bounce--small': isSmall })} />
  </div>
);

export default LoadingIndicator;
